import VirtualTourHeader from "./VirtualTourHeader";

export default VirtualTourHeader;
